export default {
  d0da9e977c8b309f93ee378de34fb251: 'Issue date',
};
